import React, { Component } from 'react'
import Axios from 'axios'
import Logo from '../Img/logo.png';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Parse from 'html-react-parser';
import {QRCodeSVG} from 'qrcode.react';
import { Base64 } from 'js-base64';


var JsBarcode = require('jsbarcode')
class PrinterPageSerieQRCODE extends React.Component {
  //add new printer
  constructor(props) {
    super(props);
    this.state = {
      user: localStorage.getItem("user")? JSON.parse(localStorage.getItem("user")) : null,
      allCartelas: [],
      allQRCodeData: [],
      serie: null,
      captura: "",
      id: "",
      nSerie: localStorage.getItem("nSerie") ?? 0,
      parametros: null
    }
    this.CapturaParametrosUrl()
    this.printar = this.printar.bind(this)
    this.getParametros()

  }
  componentDidMount() {
    // setTimeout(this.printarPagina, 4000)
    let count = 0;
    let interval = setInterval(async function(){
        if(count >= 2){
          clearInterval(interval);
          window.print()
        }
        count +=1;
    },1000)
  }



  async getParametros() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.get('parametros/get-premios')
      this.setState({ parametros: response.data })
    } catch (err) {
      console.log(err)
    }
  }


  async getTodosPedidos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("pedidos/listar-2", {});
      this.setState({ allCartelas: this.splitArrayCartelas(response.data.reverse()) });
      if (this.state.serie != null) {
        this.removerCartelaSerie()
      }
    } catch (err) {
      console.log(err);
    }
  }

  splitArrayCartelas(array) {
    var arrayCartelas = []
    array.map(element => {
      element.cartelas.map(cartela => {
        arrayCartelas.push(cartela);
      })

    })

    return arrayCartelas;
  }

  removerCartelaSerie() {

    this.state.allCartelas.map(cartela => {
      this.state.serie.cartelas.map((sCartela, index) => {
        if (sCartela.codigo == cartela.codigo) {
          this.state.serie.cartelas.splice(index, 1)
        }
      })
    })

    this.setState({ serie: this.state.serie })
    this.gerarCodigo()
    //   this.printarPagina()
  }





  printarPagina() {
    window.print()
  }

  CapturaParametrosUrl() {

    //captura a url da página
    var url = window.location.href;

    //tenta localizar o ?
    var res = url.split('?');

    if (res[1] === undefined) {
      alert('página sem parâmetros.');
    }

    if (res[1] !== undefined) {
      //tenta localizar os & (pode haver mais de 1)
      var parametros = res[1].split('&');

      //qtd. de parâmetros que serão tratados pelo laço.
      var qtdParametrosParaLer = 5;

      //guarda o nome dos parâmetros e os valores e, vetores.
      var parametroEncontrado = new Array();
      var valorParametro = new Array();

      for (var cont = 0; cont <= qtdParametrosParaLer; cont++) {
        if (parametros[cont] !== undefined) {
          this.setState({ captura: parametros[cont].split('=') })
          this.state.captura = parametros[cont].split('=');
          this.setState({ id: this.state.captura[1].toString() });
          this.state.id = this.state.captura[1].toString();


          parametroEncontrado[cont] = this.state.captura[0];
          valorParametro[cont] = this.state.captura[1];
          this.getSerie()
        }
      }
    }
  }

  async getSerie(){
    var _id = "" +  this.state.id.toString()
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.post("series/id", {id: _id})
      this.setState({ serie: response.data })
      window.localStorage.setItem('printItem', JSON.stringify(response.data))
      
      this.getTodosPedidos()


    } catch (err) {
      console.log(err)
    }
  }

  printar() {
    // window.location.to="gonative://share/sharePage"
    window.print()
  }

  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }


  gerarCodigo() {

    this.state.serie.cartelas.map(cartela => {
      JsBarcode("#aaaa" + cartela.codigo, cartela.codigo)
    })
    this.printarPagina()

  }

  render() {

    return <div >
      {/* <div className="w-100 p-2"><button className="w-100 btn-fill btn btn-danger" onClick={this.printar}><i className="fas fa-print"></i></button></div> */}
      {this.state.serie ?
        this.state.serie.cartelas.map((cartela, index) => {

          return (

            <div className='mb-1' accessKey={`keycode0${index}`}>
              <div className="text-center justify-content-center" style={{margin: 0}}>
                <div className='d-flex justify-content-center'><img style={{ maxWidth: "50%", minWidth: "50%" }} src={Logo} /></div>
                <div className='d-flex justify-content-center text-center' style={{fontSize: '14px'}}><span className="font-weight-bold text-dark" >SORTEIO - {this.formatDate(this.state.serie.cartelas[0].data)} - {this.state.serie.cartelas[0].horario ? this.state.serie.cartelas[0].horario : '20:00'} </span></div>
              </div>
              <div className="text-dark  w-100" style={{ margin: 0, display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: "center" , padding: 0, marginTop: '-4px'  }}>
                  <div className=" text-dark" style={{ display: 'flex', flexDirection: "column",  width: "100%", alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 8, paddingLeft: 32, paddingRight: 32}}>
                    <span style={{fontWeight: 'normal', fontSize: '16px'}}>Como validar sua cartelas?</span>
                    <span style={{fontWeight: 'normal', fontSize: '16px'}}>Abra a câmera do celular.</span>
                    <span style={{fontWeight: 'normal', fontSize: '16px'}}>Escaneie o QRcode. </span>
                    <span style={{fontWeight: 'normal', fontSize: '16px'}}>Preencha os dados. </span>
                    <span style={{fontWeight: 'normal', fontSize: '16px'}}>Realize o pagamento.</span>
                  </div> 
                <div className="text-dark " style={{ width: "100%", display: 'flex', flexDirection: "row", justifyContent: 'center' , alignItems: 'center', borderRadius: "8px", padding: 32}}>
                    <div className="text-dark">
                        <QRCodeSVG size={256} value={`https://cartelas.app/?qrcode=${Base64.encode(JSON.stringify({serieId: this.state.serie._id, cartelaCodigo: cartela.codigo, currentSystem: "sf"}))}`}/>
                    </div>
                </div>
              </div>
              <div class=" text-dark  w-100 text-center" style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', marginTop: '-8px' }}>
                {Parse(this.state.parametros? this.state.parametros.premios : "")}
              </div>
              {/* <div className='row justify-content-center text-center ' style={{ fontSize: '0.6em' }}><span className="ml-3 font-weight-bold" >Sº: {this.state.nSerie} / vd: {this.state.serie.cambistaId.nome} - {this.state.user.nome.substring(18,this.state.user.nome.indexOf("8") - 1)} {this.state.user.telefone}.</span> </div> */}
              <div className='d-flex justify-content-center text-center ' style={{ fontSize: '10px' }}><span className="ml-3 font-weight-bold" >S: {this.state.nSerie} |vd: {this.state.serie.cambistaId.nome}</span> </div>
              <div className='d-flex justify-content-center text-center ' style={{ fontSize: '10px' }}><span className="ml-3 font-weight-bold" >{this.state.user?this.state.user.nome : "Vendedor App" }</span> </div>
              {/* <div className='row justify-content-center text-center ' style={{ fontSize: '0.6em' }}><span className="ml-3 font-weight-bold" >{this.state.user.nome}</span> </div> */}
              <div className="mb-1 w-100 rounded">

                <div className="container text-dark border border-dark">
                  <div className="row pt-2 border border-dark text-center justify-content-center" >
                    <h6 className='text-center '><span className="font-weight-bold" style={{ fontSize: '1em' }}>R$: {cartela.valor} -  Cartela: {cartela.codigo}</span></h6>
                  </div>
                  <div className="row border border-dark">
                    <div className='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[0]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[1]}</span>
                    </div>
                    <div className='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[2]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[3]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[4]}</span>
                    </div>
                  </div>
                  <div className="row border border-dark">
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[5]}</span>
                    </div>
                    <div className='col border  border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[6]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[7]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[8]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[9]}</span>
                    </div>
                  </div>
                  <div className="row border border-dark">
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[10]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[11]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[12]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[13]}</span>
                    </div>
                    <div className='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[14]}</span>
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
            </div>


          )
        }) : ""}
    </div>

  }
}

export default PrinterPageSerieQRCODE;